import React, { useRef, useState } from 'react';
import {
    arrow,
    autoPlacement,
    autoUpdate,
    FloatingArrow,
    useFloating,
    useInteractions,
    useHover,
    useFocus,
    offset,
    shift,
    FloatingPortal
} from '@floating-ui/react';
import { cn, mergeClasses } from '#lib/helpers/class.js';

export default function FloatingTooltip(props) {
    // placement: 'left', 'right', 'top' or 'bottom'
    // show: se true il tooltip è sempre visibile
    // noHover: se true disabilita il comportamento predefinito di essere visibile con l'hover
    // noArrow: se true disabilita la freccia da cui parte il tooltip dall'UI
    // bgColor: il background color (formato CSS)
    const {
        children,
        content,
        className,
        refClassName,
        placement,
        show = false,
        noHover = false,
        noArrow = false,
        bgColor,
        textColor
    } = props;

    const [isOpen, setIsOpen] = useState(show);
    const arrowRef = useRef(null);

    const { refs, floatingStyles, context } = useFloating({
        open: show ? true : isOpen,
        onOpenChange: show || noHover ? () => {} : setIsOpen,
        whileElementsMounted: autoUpdate,
        placement: placement || 'top',
        middleware: [
            !placement && autoPlacement(),
            offset({
                mainAxis: 14
            }),
            shift(),
            arrow({
                element: arrowRef
            })
        ]
    });

    const hover = noHover || useHover(context);
    const focus = useFocus(context);

    const { getReferenceProps, getFloatingProps } = useInteractions([hover, focus]);

    return (
        <>
            <div ref={refs.setReference} {...getReferenceProps()} className={refClassName}>
                {children}
            </div>
            {(isOpen || show) && (
                <FloatingPortal>
                    <div
                        ref={refs.setFloating}
                        style={{
                            ...floatingStyles,
                            border: '1px solid grey',
                            backgroundColor: bgColor ?? '#fffe',
                            color: textColor ?? 'black'
                        }}
                        className={mergeClasses(`py-1 px-2 rounded cursor-pointer text-xs z-50`, className)}
                        {...getFloatingProps()}
                    >
                        {!noArrow && (
                            <FloatingArrow
                                stroke="grey"
                                strokeWidth={1}
                                fill={bgColor ?? '#fffe'}
                                ref={arrowRef}
                                context={context}
                            />
                        )}
                        {/* {!noArrow && <FloatingArrow className={`fill-[#0090D2]/80`} ref={arrowRef} context={context} />} */}
                        {content}
                    </div>
                </FloatingPortal>
            )}
        </>
    );
}
